<app-uni-page
  [parent]="this"
  *ngIf="isPageReady"
  pageTitle="References: Product Types"
  [bodyTemplate]="bodyTemplate"
  [footerTemplate]="footerTemplate"
></app-uni-page>
<ng-template #bodyTemplate>
  <div class="qb-list-actions">
    <div class="flex items-center gap-4">
      <p-button
        [disabled]="!this.user.isProductAdmin"
        size="small"
        (click)="addNewProductType()"
        label="Add Product Type"
        icon="pi pi-plus"
      ></p-button>
      <p-button
        [disabled]="!this.user.isProductAdmin"
        size="small"
        (click)="bulkUploadImages()"
        label="Bulk Upload Images"
        icon="pi pi-images"
      ></p-button>
      <p-radioButton [value]="false" [(ngModel)]="isShowingEmptyProductTypes" inputId="allTypes" />
      <label for="allTypes">All Product Types</label>
      <p-radioButton [value]="true" [(ngModel)]="isShowingEmptyProductTypes" inputId="emptyTypes" />
      <label for="emptyTypes">Empty Product Types</label>
    </div>
  </div>
  <p-splitter class="grow w-full qb-layout-grid" layout="vertical" styleClass="h-full" [panelSizes]="[50, 50]">
    <ng-template pTemplate>
      <div class="flex flex-col w-full h-full">
        <app-ag-grid *ngIf="!isShowingEmptyProductTypes" [gridOptions]="itsGridOptions"></app-ag-grid>
        <app-ag-grid *ngIf="isShowingEmptyProductTypes" [gridOptions]="itsEmptyGridOptions" [rowData]="productTypes"> </app-ag-grid>
      </div>
    </ng-template>
    <ng-template pTemplate>
      <div class="flex flex-col w-full h-full">
        <p-tabView (onChange)="onTabChanged($event)" class="h-full w-full uni-tabview" styleclass="h-full">
          <p-tabPanel header="Available Products">
            <div class="w-2/5 h-full">
              <app-ag-grid [gridOptions]="issGridOptions" [rowData]="products"></app-ag-grid>
            </div>
          </p-tabPanel>
          <p-tabPanel header="Alternate Product Types">
            <div class="w-2/5 h-full">
              <app-ag-grid [gridOptions]="altItsGridOptions" [rowData]="altProductTypes"></app-ag-grid>
            </div>
          </p-tabPanel>
        </p-tabView>
      </div>
    </ng-template>
  </p-splitter>
</ng-template>
<ng-template #footerTemplate>
  <div class="left-buttons">
    <button pButton type="button" class="p-button-raised" icon="pi pi-arrow-left" (click)="goBack()">
      <span>Go Back</span>
    </button>
  </div>
</ng-template>
